<template>
  <v-navigation-drawer
    id="left-drawer"
    clipped
    app
    fixed
    hide-overlay
    permanent
    :mini-variant="mini"
    persistent
  >
    <v-list class="pt-0">
      <v-list-item v-show="mini">
        <v-list-item-avatar size="32" class="">
          <v-img src="assets/images/LogoSpideUpBlack.png"></v-img>
        </v-list-item-avatar>
      </v-list-item>

      <v-list-item v-show="!mini" class="logo-container">
        <v-list-item-content>
          <!-- <div class="text-center pb-1">
            <span>Spide</span>
            <span class="mx-1">|</span>
            <span><strong>UP</strong></span>
          </div> -->
          <v-img src="assets/images/LogoSpideUp.png"></v-img>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-list-group
      v-for="(item, index) in navigation"
      :key="item.code"
      v-model="item.active"
      :value="true"
      class="nav-item-box"
      :class="{
        'no-childs': item.childs.length === 0,
        'nav-active': item.target === currentRouteGroup,
      }"
      no-action
    >
      <template v-slot:activator>
        <v-list-item-icon @click="goto(item.target)">
          <div class="nav-item-decoration"></div>
          <v-icon class="material-icons-outlined nav-item-icon">{{
            item.icon
          }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content @click="goto(item.target)">
          <v-list-item-title
            class="nav-item"
            v-text="$t(`ui.navigation-drawer.links.${item.code}`)"
          />
        </v-list-item-content>
      </template>

      <v-list-item
        v-if="item.childs.length > 0"
        v-for="(child, index) in item.childs"
        :key="child.code"
        @click="goto(child.target, child.params ? child.params : {})"
        :class="{
          'sub-nav-active': child.target === currentRouteSubGroup,
        }"
        link
      >
        <v-list-item-content>
          <v-list-item-title
            v-text="$t(`ui.navigation-drawer.links.${child.code}`)"
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>

    <v-list-group
      key="help"
      class="nav-item-box no-childs"
      no-action
      @click="gotoHelp()"
    >
      <template v-slot:activator>
        <v-list-item-icon >
          <div class="nav-item-decoration"></div>
          <v-icon class="material-icons-outlined nav-item-icon">help_center</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            class="nav-item"
          >
            Besoin d'aide ?
          </v-list-item-title>
        </v-list-item-content>
      </template>
    </v-list-group>
<!-- 
    <div class="text-center mt-10">
      <v-btn class="theme-btn shape-rounded filled-purple glow drawer-button"
        >Besoin d'aide ?</v-btn
      >
    </div> -->
  </v-navigation-drawer>
</template>

<script type="text/javascript">
export default {
  name: 'left-drawer',
  components: {},
  data() {
    return {
      selected: 'workflows',
    };
  },
  props: {
    mini_forced: {
      default: false,
    }
  },
  computed: {
    mini() {
      return this.mini_forced || this.$vuetify.breakpoint.smAndDown;
    },
    navigation() {
      return this.$store.state.navigation;
    },
    currentRouteGroup() {
      if (this.$route.matched.length > 1) {
        return this.$route.matched[1].name;
      }
      return null;
    },
    currentRouteSubGroup() {
      if (this.$route.matched.length > 2) {
        return this.$route.matched[2].name;
      }
      return null;
    },
  },
  created() {},
  methods: {
    goto(target, params = null) {
      console.log('goto')
      console.log(params)
      let targs = target.toLowerCase();
      let pathRouter = this.$route.path;
      if (!pathRouter.includes(targs)) {
        this.$router.push({ name: target });
      }
    },
    gotoHelp() {
      window.open("https://demo.spideup.com/fr/faq-details", "_blank")
    }
  },
};
</script>

<style lang="scss">
#left-drawer {
  background-color: $color-secondary-hover;

  .logo-container {
    background-color: $color-primary;
    color: white !important;
    .v-list-item__content {
      span {
        font-size: 34px;
        display: inline;
      }
    }
  }

  .nav-item-box {
    .nav-item-decoration {
      transition-duration: 0.2s;
      opacity: 0;
    }
    .nav-item-icon {
      color: $color-white;
    }
    .nav-item {
      color: $color-white;
    }

    .v-list-group__header__append-icon {
      display: none;
    }

    &.no-childs {
      .v-list-group__items {
        display: none;
      }
    }
    .v-list-item__content {
        color: $color-white-dark;
      }
    &.nav-active {
      
      
      & > .v-list-item:nth-child(1) {
        background-color: $color-secondary-hue;
        border-right: solid 6px $color-primary;
        .nav-item-decoration {
          position: absolute;
          right: 0px;
          top: 0px;
          height: 100%;
          width: 5px;
          background-color: $color-secondary;
          opacity: 1;
        }
        .nav-item-icon {
          color: $color-primary;
        }
        .nav-item {
          color: $color-primary;
        }
      }
    }

    .sub-nav-active .v-list-item__content {
      color: $color-primary !important;
      font-weight: bold;
    }
  }

  .drawer-button {
    margin: 0 auto;
  }

  .v-navigation-drawer__border {
    background-color: transparent;
  }
}
</style>
